import { ActionTypes } from './actionTypes';

export type Payload = Record<string, unknown>;

export type MetricDefinitionsAction<T = Record<string, unknown>, P = Payload> = {
  type: ActionTypes;
  payload?: P;
} & T;

/*------------------------------------------------------------------------------------------------*/
/* Analytics Metric Definitions Actions                                                                         */
/*------------------------------------------------------------------------------------------------*/
/**
 * fetchAnalyticsMetricDefinitions
 * API Posts the request.
 * @param { Object } request: the request object.
 * @returns { Object } action.
 */
export const fetchAnalyticsMetricDefinitions = (request: string) => ({
  type: ActionTypes.FETCH_ANALYTICS_METRIC_DEFINITIONS_REQUEST,
  request,
});

/**
 * fetchAnalyticsMetricDefinitionsError
 * Error posting request.
 * @returns { Object } action.
 */
export const fetchAnalyticsMetricDefinitionsError = () => ({
  type: ActionTypes.FETCH_ANALYTICS_METRIC_DEFINITIONS_ERROR,
});

/**
 * fetchAnalyticsMetricDefinitionsResponse
 * API post response.
 * @param { Object } response: The post request response.
 * @returns { Object } action.
 */
export const fetchAnalyticsMetricDefinitionsResponse = (response: object) => ({
  type: ActionTypes.FETCH_ANALYTICS_METRIC_DEFINITIONS_RESPONSE,
  response,
});

/**
 * updateAnalyticsMetricDefinition
 * API Posts the request.
 * @param { Object } request: the request object.
 * @returns { Object } action.
 */
export const updateAnalyticsMetricDefinition = (request: object) => ({
  type: ActionTypes.UPDATE_ANALYTICS_METRIC_DEFINITION_REQUEST,
  request,
});

/**
 * updateAnalyticsMetricDefinitionError
 * Error posting request.
 * @returns { Object } action.
 */
export const updateAnalyticsMetricDefinitionError = () => ({
  type: ActionTypes.UPDATE_ANALYTICS_METRIC_DEFINITION_ERROR,
});

/**
 * updateAnalyticsMetricDefinitionResponse
 * API post response.
 * @param { Object } response: The post request response.
 * @returns { Object } action.
 */
export const updateAnalyticsMetricDefinitionResponse = (response: object) => ({
  type: ActionTypes.UPDATE_ANALYTICS_METRIC_DEFINITION_RESPONSE,
  response,
});

/**
 * createAnalyticsMetricDefinition
 * API Posts the request.
 * @param { Object } request: the request object.
 * @returns { Object } action.
 */
export const createAnalyticsMetricDefinition = (request: object) => ({
  type: ActionTypes.CREATE_ANALYTICS_METRIC_DEFINITION_REQUEST,
  request,
});

/**
 * createAnalyticsMetricDefinitionError
 * Error posting request.
 * @returns { Object } action.
 */
export const createAnalyticsMetricDefinitionError = () => ({
  type: ActionTypes.CREATE_ANALYTICS_METRIC_DEFINITION_ERROR,
});

/**
 * createAnalyticsMetricDefinitionResponse
 * API post response.
 * @param { Object } response: The post request response.
 * @returns { Object } action.
 */
export const createAnalyticsMetricDefinitionResponse = (response: object) => ({
  type: ActionTypes.CREATE_ANALYTICS_METRIC_DEFINITION_RESPONSE,
  response,
});

/**
 * bulkUpdateAnalyticsMetricDefinition
 * API Posts the request.
 * @param { Object } request: the request object.
 * @returns { Object } action.
 */
export const bulkUpdateAnalyticsMetricDefinition = (request: object) => ({
  type: ActionTypes.BULK_UPDATE_ANALYTICS_METRIC_DEFINITION_REQUEST,
  request,
});

/**
 * bulkUpdateAnalyticsMetricDefinitionError
 * Error posting request.
 * @returns { Object } action.
 */
export const bulkUpdateAnalyticsMetricDefinitionError = () => ({
  type: ActionTypes.BULK_UPDATE_ANALYTICS_METRIC_DEFINITION_ERROR,
});

/**
 * bulkUpdateAnalyticsMetricDefinitionResponse
 * API post response.
 * @param { Object } response: The post request response.
 * @returns { Object } action.
 */
export const bulkUpdateAnalyticsMetricDefinitionResponse = (response: object) => ({
  type: ActionTypes.BULK_UPDATE_ANALYTICS_METRIC_DEFINITION_RESPONSE,
  response,
});

/**
 * deleteAnalyticsMetricDefinition
 * API Posts the request.
 * @param { Object } request: the request object.
 * @returns { Object } action.
 */
export const deleteAnalyticsMetricDefinition = (request: object) => ({
  type: ActionTypes.DELETE_ANALYTICS_METRIC_DEFINITION_REQUEST,
  request,
});

/**
 * deleteAnalyticsMetricDefinitionError
 * Error posting request.
 * @returns { Object } action.
 */
export const deleteAnalyticsMetricDefinitionError = () => ({
  type: ActionTypes.DELETE_ANALYTICS_METRIC_DEFINITION_ERROR,
});

/**
 * deleteAnalyticsMetricDefinitionResponse
 * API post response.
 * @param { Object } response: The post request response.
 * @returns { Object } action.
 */
export const deleteAnalyticsMetricDefinitionResponse = (response: object) => ({
  type: ActionTypes.DELETE_ANALYTICS_METRIC_DEFINITION_RESPONSE,
  response,
});

/*------------------------------------------------------------------------------------------------*/
/* High Level Metric Definitions Actions                                                                         */
/*------------------------------------------------------------------------------------------------*/
/**
 * fetchHighLevelMetricDefinitions
 * API Posts the request.
 * @param { Object } request: the request object.
 * @returns { Object } action.
 */
export const fetchHighLevelMetricDefinitions = (request: string) => ({
  type: ActionTypes.FETCH_HIGH_LEVEL_METRIC_DEFINITIONS_REQUEST,
  request,
});

/**
 * fetchHighLevelMetricDefinitionsError
 * Error posting request.
 * @returns { Object } action.
 */
export const fetchHighLevelMetricDefinitionsError = () => ({
  type: ActionTypes.FETCH_HIGH_LEVEL_METRIC_DEFINITIONS_ERROR,
});

/**
 * fetchHighLevelMetricDefinitionsResponse
 * API post response.
 * @param { Object } response: The post request response.
 * @returns { Object } action.
 */
export const fetchHighLevelMetricDefinitionsResponse = (response: object) => ({
  type: ActionTypes.FETCH_HIGH_LEVEL_METRIC_DEFINITIONS_RESPONSE,
  response,
});

/**
 * updateHighLevelMetricDefinition
 * API Posts the request.
 * @param { Object } request: the request object.
 * @returns { Object } action.
 */
export const updateHighLevelMetricDefinition = (request: object) => ({
  type: ActionTypes.UPDATE_HIGH_LEVEL_METRIC_DEFINITION_REQUEST,
  request,
});

/**
 * updateHighLevelMetricDefinitionError
 * Error posting request.
 * @returns { Object } action.
 */
export const updateHighLevelMetricDefinitionError = () => ({
  type: ActionTypes.UPDATE_HIGH_LEVEL_METRIC_DEFINITION_ERROR,
});

/**
 * updateHighLevelMetricDefinitionResponse
 * API post response.
 * @param { Object } response: The post request response.
 * @returns { Object } action.
 */
export const updateHighLevelMetricDefinitionResponse = (response: object) => ({
  type: ActionTypes.UPDATE_HIGH_LEVEL_METRIC_DEFINITION_RESPONSE,
  response,
});

/**
 * createHighLevelMetricDefinition
 * API Posts the request.
 * @param { Object } request: the request object.
 * @returns { Object } action.
 */
export const createHighLevelMetricDefinition = (request: object) => ({
  type: ActionTypes.CREATE_HIGH_LEVEL_METRIC_DEFINITION_REQUEST,
  request,
});

/**
 * createHighLevelMetricDefinitionError
 * Error posting request.
 * @returns { Object } action.
 */
export const createHighLevelMetricDefinitionError = () => ({
  type: ActionTypes.CREATE_HIGH_LEVEL_METRIC_DEFINITION_ERROR,
});

/**
 * createHighLevelMetricDefinitionResponse
 * API post response.
 * @param { Object } response: The post request response.
 * @returns { Object } action.
 */
export const createHighLevelMetricDefinitionResponse = (response: object) => ({
  type: ActionTypes.CREATE_HIGH_LEVEL_METRIC_DEFINITION_RESPONSE,
  response,
});

/**
 * bulkUpdateHighLevelMetricDefinition
 * API Posts the request.
 * @param { Object } request: the request object.
 * @returns { Object } action.
 */
export const bulkUpdateHighLevelMetricDefinition = (request: object) => ({
  type: ActionTypes.BULK_UPDATE_HIGH_LEVEL_METRIC_DEFINITION_REQUEST,
  request,
});

/**
 * bulkUpdateHighLevelMetricDefinitionError
 * Error posting request.
 * @returns { Object } action.
 */
export const bulkUpdateHighLevelMetricDefinitionError = () => ({
  type: ActionTypes.BULK_UPDATE_HIGH_LEVEL_METRIC_DEFINITION_ERROR,
});

/**
 * bulkUpdateHighLevelMetricDefinitionResponse
 * API post response.
 * @param { Object } response: The post request response.
 * @returns { Object } action.
 */
export const bulkUpdateHighLevelMetricDefinitionResponse = (response: object) => ({
  type: ActionTypes.BULK_UPDATE_HIGH_LEVEL_METRIC_DEFINITION_RESPONSE,
  response,
});

/**
 * deleteHighLevelMetricDefinition
 * API Posts the request.
 * @param { Object } request: the request object.
 * @returns { Object } action.
 */
export const deleteHighLevelMetricDefinition = (request: object) => ({
  type: ActionTypes.DELETE_HIGH_LEVEL_METRIC_DEFINITION_REQUEST,
  request,
});

/**
 * deleteHighLevelMetricDefinitionError
 * Error posting request.
 * @returns { Object } action.
 */
export const deleteHighLevelMetricDefinitionError = () => ({
  type: ActionTypes.DELETE_HIGH_LEVEL_METRIC_DEFINITION_ERROR,
});

/**
 * deleteHighLevelMetricDefinitionResponse
 * API post response.
 * @param { Object } response: The post request response.
 * @returns { Object } action.
 */
export const deleteHighLevelMetricDefinitionResponse = (response: object) => ({
  type: ActionTypes.DELETE_HIGH_LEVEL_METRIC_DEFINITION_RESPONSE,
  response,
});
